const config = {
  API_BASE_URL: process.env.GATSBY_API_URL,
  AMANPAY_ACCESS_KEY: process.env.GATSBY_AMANPAY_ACCESS_KEY,
  AMANPAY_MERCHANT_ID: process.env.GATSBY_AMANPAY_MERCHANT_ID,
  GOOGLE_MAP_API_KEY: process.env.GATSBY_GOOGLE_MAP_API_KEY,
  GATSBY_GOOGLE_MAP_ID_1: process.env.GATSBY_GOOGLE_MAP_ID_1,
  RECAPTCHA_SITE_KEY: process.env.GATSBY_RECAPTCHA_SITE_KEY,
};

export default config;
